<template>
  <b-modal 
    :title="title"
    v-model="showModal"
    @ok.prevent="submit(false)"
    :ok-disabled="sending"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form>
      <b-form-group label="Name"
        label-for="user-name"
        invalid-feedback="Please enter a name"
        :state="errors.length == 0 ? null : form.name !== ''"
      >
        <b-form-input
          id="user-name"
          v-model.trim="form.name"
          required
          autofocus
          maxlength="100"
          :state="errors.length == 0 ? null : form.name !== ''"
        ></b-form-input>
      </b-form-group>
      <div v-if="allowGuest">
        <b-form-group label="Email"
          v-if="allowGuest"
          label-for="user-email"
          invalid-feedback="Please enter an email"
          :state="errors.length == 0 ? null : validEmail(form.email)"
        >
          <b-form-input id="user-email"
            v-model.trim="form.email"
            required
            maxlength="254"
            :state="errors.length == 0 ? null : validEmail(form.email) ? mode === 'Edit' ? null : true : false"
            :disabled="mode === 'Edit'"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Organization"
          v-if="mode === 'Add'"
          label-for="user-organization"
        >
          <b-input-group>
            <b-form-select
              id="user-organization"
              v-model="form.organization"
              :options="organizationOptions"
              @change="onOrganizationChange"
            ></b-form-select>
            <b-input-group-append v-if="form.organization === ''">
              <b-button v-on:click="addOrganization">Add</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <!-- <b-form-group
          label="Role"
          v-if="mode === 'Add'"
          label-for="user-organization-role"
        >
          <b-form-select
            id="user-organization-role"
            v-model="form.role"
            :options="roleOptions"
          ></b-form-select>
        </b-form-group> -->
        <b-form-group>
          <b-form-checkbox
            id="user-is-guest"
            v-model="form.isGuest"
          >
            This is a guest
          </b-form-checkbox>
        </b-form-group>
      </div>
      <div v-if="!allowGuest || !form.isGuest">
          <b-form-group label="Job Title"
          label-for="user-job-title"
          invalid-feedback="Please enter a job title"
          :state="errors.length == 0 ? null : form.name !== ''"
        >
          <b-form-input
            id="user-job-title"
            v-model.trim="form.jobTitle"
            maxlength="50"
            :state="errors.length == 0 ? null : form.jobTitle ? true : null"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Email"
          v-if="!allowGuest"
          label-for="user-email"
          invalid-feedback="Please enter an email"
          :state="errors.length == 0 ? null : validEmail(form.email)"
        >
          <b-form-input id="user-email"
            v-model.trim="form.email"
            required
            maxlength="254"
            :state="errors.length == 0 ? null : validEmail(form.email) ? mode === 'Edit' ? null : true : false"
            :disabled="mode === 'Edit'"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Mobile Phone"
          label-for="user-phone"
          invalid-feedback="Please enter a valid phone number"
        >
          <b-form-input
            id="user-phone"
            v-model="form.phone"
            type="tel"
            :state="errors.length == 0 ? null : validPhone"
            v-mask="'(###) ###-####'"
          ></b-form-input>
        </b-form-group>
        <div v-if="!allowGuest">
          <b-form-group label="Organization"
            v-if="mode === 'Add'"
            label-for="user-organization"
            invalid-feedback="Please select a orgnazination"
            :state="errors.length == 0 ? null : form.organization !== ''"
          >
            <b-input-group>
              <b-form-select
                id="user-organization"
                v-model="form.organization"
                required
                :options="organizationOptions"
                @change="onOrganizationChange"
                :state="errors.length == 0 ? null : form.organization !== ''"
              ></b-form-select>
              <b-input-group-append v-if="form.organization === ''">
                <b-button v-on:click="addOrganization">Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <!-- <b-form-group
            label="Role"
            v-if="mode === 'Add'"
            label-for="user-organization-role"
            invalid-feedback="Please select a role"
            :state="errors.length == 0 ? null : form.role !== ''"
          >
            <b-form-select
              id="user-organization-role"
              v-model="form.role"
              required
              :state="errors.length == 0 ? null : form.role !== ''"
              :options="roleOptions"
            ></b-form-select>
          </b-form-group> -->
        </div>
        <b-form-group 
          v-if="form.role != 'Facilitator'"
          label="User Type"
          label-for="user-permission-level"
          invalid-feedback="Please select a user type"
          :state="errors.length == 0 ? null : form.permissionLevel !== ''"
        >
          <b-form-select
            id="user-permission-level"
            v-model="form.permissionLevel"
            required
            :state="errors.length == 0 ? null : form.permissionLevel !== ''"
          >
            <option value="Respondent">Evaluation respondent</option>
            <option value="Admin">Admin</option>
            <!-- <option value="Sponsor">Executive</option> -->
          </b-form-select>
        </b-form-group>
        <b-form-group
          v-if="form.role != 'Facilitator'"
          label="Send Survey?" 
          label-for="user-send-survey">
          <b-form-select id="user-send-survey" v-model="form.sendSurvey" :state="errors.length == 0 ? null : true">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </b-form-select>
        </b-form-group>
      </div>
    </b-form>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
    <template v-slot:modal-ok >
      <div style="width: 36px;" >
        <b-spinner v-if="sending" small label="Spinning"/>
        <div v-else-if="mode === 'Add'">Add</div>
        <div v-else-if="mode === 'Edit'">Save</div>
      </div>
    </template>
    <AddOrganizationModal
      ref="add-organization-modal"
      :organizations="organizations"
      @add="addOrganizationSubmit">
    </AddOrganizationModal>
  </b-modal>
</template>
<script>
import axios from "axios";
import ConfirmExistingUserModal from "@/modal-components/ConfirmExistingUserModal.vue";
import AddOrganizationModal from "@/modal-components/AddOrganizationModal.vue";

export default {
  props: {
    mode: { type: String, default: "Edit" },
    projectUser: { type: Object, default: null }, //Edit
    projectId: { type: String, default: '' }, //Add
    users: { type: Array, default: () => [] }, //Add
    organizations: { type: Array, default: () => [] }, //Add
    name: { type: String, default: '' },
    allowGuest: { type: Boolean, default: false },
    isGuestDefault: { type: Boolean, default: true },
  },
  components: {
    ConfirmExistingUserModal,
    AddOrganizationModal
  },
  data() {
    return {
      errors: [],
      showModal: false,
      sending: false,
      form: {
        userId: '',
        name: '',
        jobTitle: '',
        email: '',
        phone: '',
        organization: '',
        role: "Owner",
        permissionLevel: "Respondent",
        sendSurvey: true,
        isGuest: this.isGuestDefault
      },
      addedOrganization: null,
      existingUser: {
        name: '',
        jobTitle: '',
        email: '',
        phone: ''
      },
      // roleOptions: [
      //   { value: 'Owner', text: 'Owner' },
      //   { value: 'Contractor', text: 'Contractor' },
      //   { value: 'Facilitator', text: 'Facilitator'}
      // ]
    }
  },
  methods: {
    show() {
      this.showModal = true;
      this.loadUser(this.projectUser);
      if (this.mode === 'Add' && this.name.length > 0) {
        this.form.name = this.name;
      }
      if (this.isGuestDefault) {
        this.form.isGuest = true;
      }
    },
    hide() {
      this.showModal = false;
    },
    cancel() {
      this.resetForm();
      this.hide();
    },
    submit(force) {
      if (this.mode === 'Add') {
        this.addUser(force);
      } else {
        this.editUser();
      }
    },
    updateFieldsForGuest() {
      this.form.jobTitle = '';
      this.form.phone = '';
      this.form.organization = '00000000-0000-0000-0000-000000000000';
      this.form.role = 'Guest';
      this.form.permissionLevel = 'Guest';
      this.form.sendSurvey = false;
    },
    addUser(force) {
      this.errors = [];

      if (this.allowGuest && this.form.isGuest) {
        this.updateFieldsForGuest();
      }

      if (!this.validateUser(this.form)) {
        return;
      }

      const userId = this.$helpers.generateUUID();
      this.form.userId = userId;

      let request = {
        user: {
          userId: userId,
          name: this.form.name,
          jobTitle: this.form.jobTitle,
          email: this.form.email,
          phone: this.form.phone
        },
        relation: {
          userId: userId,
          projectId: this.projectId,
          organizationId: this.form.organization,
          role: this.form.role,
          permissionLevel: this.form.permissionLevel,
          sendSurvey: this.form.sendSurvey
        },
        organization: null
      };

      if (this.addedOrganization &&
        !this.organizations.some(o => o.organizationId === this.addedOrganization.organizationId)) {
        request.organization = this.addedOrganization;
      }

      if (request.relation.role == 'Facilitator') {
        request.relation.permissionLevel = 'Admin';
        request.relation.sendSurvey = false;
      }

      let url = `${this.$api_url}/projects/${this.projectId}/users/add`;
      if (force){
        url += '?force=true';
      }
      
      this.sending = true;
      axios
        .post(url, request, this.getReqConfig())
        .then(() => {
          //Add it to the list of project users
          this.$emit('submitted',this.form);
          this.resetForm();
          this.hide();
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.confirmUser(err.response.data);
          } else {
            this.errors.push(...this.$helpers.formatErrors(err));
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    editUser() {
      this.errors = [];

      if (!this.validateUser(this.form)) {
        return;
      }

      let request = {
        user: {
          userId: this.form.userId,
          name: this.form.name,
          jobTitle: this.form.jobTitle,
          email: null,
          phone: this.form.phone
        },
        relation: {
          userId: this.form.userId,
          projectId: this.projectId,
          organizationId: this.projectUser.organizationId,
          role: this.projectUser.role,
          permissionLevel: this.form.permissionLevel,
          sendSurvey: this.form.sendSurvey
        }
      };

      if (request.relation.role == 'Facilitator') {
        request.relation.permissionLevel = 'Admin';
        request.relation.sendSurvey = false;
      }

      this.sending = true;
      axios
        .post(`${this.$api_url}/projects/${this.projectId}/users/update`, request, this.getReqConfig())
        .then(() => {
          this.$emit('submit');
          this.resetForm();
          this.hide();
        })
        .catch(err => {
          this.errors.push(...this.$helpers.formatErrors(err));
        })
        .finally(() => {
          this.sending = false;
        });
    },
    loadUser(user) {
      if (user) {
        this.form = {
          ...user,
          // organization: "",
          // role: "Owner",
        };
      }
    },
    validateUser(userForm){
      const initErrors = this.errors.length;
      let email = userForm.email.trim().toLowerCase();

      if (!userForm.name) {
        this.errors.push({ message: 'Name cannot be empty'})
      }

      if (!userForm.email.length) {
        this.errors.push({message: 'Email cannot be empty' })
      } else if (!this.validEmail(userForm.email)){
        this.errors.push({ message: 'Email must be valid' });
      } else if (this.users.find(u => u.email === email)){
        this.errors.push({
          message: `User with email '${email}' is already part of this project`
        });
      }

      if (this.validPhone === false) {
        this.errors.push({message: 'Phone number must be 10 digits long'})
      }

      return initErrors === this.errors.length;
    },
    validateGuest(userForm){
      const initErrors = this.errors.length;
      let email = userForm.email.trim().toLowerCase();

      if (!userForm.name) {
        this.errors.push({ message: 'Name cannot be empty'})
      }

      if (!userForm.email.length) {
        this.errors.push({message: 'Email cannot be empty' })
      } else if (!this.validEmail(userForm.email)){
        this.errors.push({ message: 'Email must be valid' });
      } else if (this.users.find(u => u.email === email)){
        this.errors.push({
          message: `User with email '${email}' is already part of this project`
        });
      }

      return initErrors === this.errors.length;
    },
    validEmail(email){
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    confirmUser(user) {
      this.form.userId = user.userId;
      this.existingUser.name = user.name;
      this.existingUser.email = user.email;
      this.existingUser.phone = user.phone;
      this.submit(true);
    },
    resetForm() {
      this.errors = [];
      this.form = {
        userId: '',
        name: '',
        jobTitle: '',
        email: '',
        phone: '',
        organization: '',
        role: "Owner",
        permissionLevel: "Respondent",
        sendSurvey: true,
        isGuest: this.isGuestDefault
      };
      this.addedOrganization = null;
      // this.roleOptions = [
      //   { value: 'Owner', text: 'Owner' },
      //   { value: 'Contractor', text: 'Contractor' },
      //   { value: 'Facilitator', text: 'Facilitator'}
      // ];
      this.resetExistingUser();
    },
    resetExistingUser() {
      this.existingUser =  {
        name: '',
        jobTitle: '',
        email: '',
        phone: ''
      };
    },
    onOrganizationChange() {
      this.updateRole();
      // this.updateRoleOptions();
    },
    addOrganization() {
      this.$refs["add-organization-modal"].show();
    },
    addOrganizationSubmit(organization) {
      this.addedOrganization = organization;
      this.form.organization = organization.organizationId;
    },
    updateRole() {
      const organization = this.projectOrganizations
        .find(o => o.organizationId === this.form.organization);

      if (organization) {
        this.form.role = this.users.find(u => u.organization === organization.name).role;
      }
    }
    // updateRoleOptions() {
    //   let organization = this.projectOrganizations
    //     .find(o => o.organizationId === this.form.organization);
      
    //   if (organization) {
    //     let role = this.users.find(u => u.organization === organization.name).role;
    //     this.roleOptions = [ 
    //       { value: role, text: role },
    //       { value: 'Facilitator', text: 'Facilitator'}
    //     ];
    //     this.form.role = role;
    //   }
    //   else {
    //     this.form.role = 'Owner';
    //     this.roleOptions = [
    //       { value: 'Owner', text: 'Owner' },
    //       { value: 'Contractor', text: 'Contractor' },
    //       { value: 'Facilitator', text: 'Facilitator'}
    //     ]
    //   }
    // }
  },
  computed: {
    title() {
      return this.mode === "Add" ? "Add User" : "Edit User";
    },
    organizationOptions() {
      let options = [];
      if (this.addedOrganization){
        options.push({
          value: this.addedOrganization.organizationId,
          text: this.addedOrganization.name
        });
      }
      else{
        options.push({value: '', text: ''});
        const organizations = this.projectOrganizations;
        options.push(...organizations.map(o => ({
          value: o.organizationId,
          text: o.name
        })));
      }
      return options;
    }, 
    projectOrganizations() {
      let organizationNames = new Set(this.users.map(u => u.organization));
      return this.organizations.filter(o => organizationNames.has(o.name));
    },
    validPhone() {
      return this.form.phone
        ? this.form.phone.replace(/[^0-9]/g, '').length === 10
        : null
    }
  },
}
</script>